export default {
    root: {
        marginLeft: '0',
        marginRight: '0'
    },
    regular: {
        minHeight: 0
    }
};
